module.exports = __webpack_public_path__ + "img/alert.f5c1ea5a.svg";